<template>
  <DefaultLayout
    :pageProps="{
      title: 'Reset password',
    }"
  >
    <template #content>
      <div v-if="verifying && !failed" class="text-center">
        <div class="main-title">Verifying ...</div>
      </div>
      <div
        v-else
        class="d-flex justify-content-center flex-column text-center"
        style="gap: 20px"
      >
        <div v-if="failed">
          <div class="main-title subtitle-red" id="mainTitleFailed">
            Verification failed
          </div>
          <div>
            Verification link is no longer valid. Click the button below to get
            a new link.
          </div>
        </div>
        <div v-else>
          <div class="main-title-small subtitle-green" id="mainTitleSuccess">
            Success, your email was verified! 🎉
          </div>
          <div>Redirecting you to {{ customer.name }}...</div>
        </div>
        <SubmitButton
          v-if="!failed && !verifying"
          text="Open Loop"
          @click.native="backToTheApp"
        />
        <SubmitButton
          v-else-if="failed && !verifying"
          :loading="loading"
          id="resendVerificationEmail"
          text="Resend verification email"
          @click.native="resendVerificationEmail"
        />
      </div>
      <ToastSuccess size="large">
        <div>
          We've sent an email to
          <b>{{ email }}</b>
          <br />
          Please check your email and verify your account to continue. If you
          can't find our email, please check your "Spam" folder.
        </div>
      </ToastSuccess>
      <ToastError
        text="There was a problem sending an email. Please try again later."
      >
        <template>
          <div>Error: {{ toastMessage }}</div>
        </template>
      </ToastError>
    </template>
  </DefaultLayout>
</template>

<script>
import SubmitButton from "@/components/buttons/SubmitButton";
import forgotPassword from "@/mixins/loopLogin/forgotPassword";
import ToastSuccess from "@/components/toast/ToastSuccess";
import verify from "@/mixins/loopLogin/verify";
import ToastError from "@/components/toast/ToastError";
import DefaultLayout from "../../layout/DefaultLayout.vue";
import { CUSTOMER } from "@/environment/env.customer";

export default {
  name: "index",
  components: {
    DefaultLayout,
    ToastError,
    ToastSuccess,
    SubmitButton,
  },
  mixins: [forgotPassword, verify],
  data() {
    return {
      customer: CUSTOMER,
    };
  },
};
</script>
